var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择样式")
    }
  }, [_c("div", {
    staticClass: "imgList"
  }, [_vm.$route.params.type == "INVOICE_DETAIL_PAGE" ? _vm._l(_vm.configureList, function (item, index) {
    return item.mark != "bottomButton1" && item.mark != "bottomButton2" ? _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon,
        alt: "pic"
      }
    })]) : _vm._e();
  }) : _vm._l(_vm.configureList, function (item, index) {
    return _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon,
        alt: "pic"
      }
    })]);
  })], 2)]), _vm.$route.params.type == "DETAILS" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择按钮")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isPremium
    },
    on: {
      change: _vm.changeremiumFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保费试算")) + " ")]), _vm.form.isPremium ? _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.buttonColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.buttonColor, "buttonFontColor", -1);
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._l(_vm.form.buttonInfo, function (item, index) {
    return _c("a-form-model-item", {
      key: index,
      staticClass: "btnBox",
      attrs: {
        label: _vm.$t("按钮设置") + (index + 1)
      }
    }, [index != 0 ? _c("a-icon", {
      staticClass: "icon",
      attrs: {
        type: "delete"
      },
      on: {
        click: function ($event) {
          return _vm.delBtnFun(index);
        }
      }
    }) : _vm._e(), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + item.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(item.buttonFontColor, "buttonFontColor", index);
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + item.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun(item.buttonBgColor, "buttonBgColor", index);
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("a-input", {
      attrs: {
        maxLength: 15,
        placeholder: _vm.$t("请输入") + "1-15" + _vm.$t("字符")
      },
      on: {
        change: function ($event) {
          return _vm.handleBlurTrim(item.buttonName, index);
        }
      },
      model: {
        value: item.buttonName,
        callback: function ($$v) {
          _vm.$set(item, "buttonName", $$v);
        },
        expression: "item.buttonName"
      }
    })], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("a-checkbox", {
      attrs: {
        checked: item.buttonPopUp
      },
      on: {
        change: e => _vm.onChangePopup(e, index)
      }
    }, [_vm._v(_vm._s(_vm.$t("添加按钮弹窗")))])], 1), item.buttonPopUp ? _c("div", {
      staticClass: "popup"
    }, [_c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("弹窗位置")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("a-radio-group", {
      on: {
        change: _vm.changeFun
      },
      model: {
        value: item.buttonPopUpConfig.popUpPosition,
        callback: function ($$v) {
          _vm.$set(item.buttonPopUpConfig, "popUpPosition", $$v);
        },
        expression: "item.buttonPopUpConfig.popUpPosition"
      }
    }, [_c("a-radio", {
      attrs: {
        value: "central"
      }
    }, [_vm._v(_vm._s(_vm.$t("中部")))]), _c("a-radio", {
      attrs: {
        value: "bottom"
      }
    }, [_vm._v(_vm._s(_vm.$t("底部")))])], 1)], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("提示标题")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("a-input", {
      attrs: {
        placeholder: _vm.$t("请输入") + "2-15" + _vm.$t("字符")
      },
      on: {
        change: _vm.changeFun
      },
      model: {
        value: item.buttonPopUpConfig.popUpTitle,
        callback: function ($$v) {
          _vm.$set(item.buttonPopUpConfig, "popUpTitle", $$v);
        },
        expression: "item.buttonPopUpConfig.popUpTitle"
      }
    })], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("弹窗内容")))]), _c("div", {
      staticClass: "contBox",
      staticStyle: {
        height: "auto"
      }
    }, [_c("a-textarea", {
      attrs: {
        rows: 3,
        placeholder: _vm.$t("请输入") + "5-100" + _vm.$t("字符")
      },
      on: {
        change: _vm.changeFun
      },
      model: {
        value: item.buttonPopUpConfig.popUpContent,
        callback: function ($$v) {
          _vm.$set(item.buttonPopUpConfig, "popUpContent", $$v);
        },
        expression: "item.buttonPopUpConfig.popUpContent"
      }
    })], 1)]), _vm._l(item.buttonPopUpConfig.buttonInfo, function (item1, index1) {
      return _c("div", {
        key: index1,
        staticClass: "btnBox"
      }, [_c("div", {
        staticStyle: {
          "font-weight": "700"
        }
      }, [_vm._v("-" + _vm._s(_vm.$t("弹窗按钮") + (index1 + 1)) + ":")]), index1 != 0 ? _c("a-icon", {
        staticClass: "icon",
        staticStyle: {
          top: "10px"
        },
        attrs: {
          type: "delete"
        },
        on: {
          click: function ($event) {
            return _vm.delPopupBtnFun(index, index1);
          }
        }
      }) : _vm._e(), _c("div", {
        staticClass: "selectedItem"
      }, [_c("div", {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
        staticClass: "contBox"
      }, [_c("div", {
        staticClass: "colorBox",
        style: "background:" + item1.buttonFontColor
      }), _c("a-button", {
        staticClass: "size",
        attrs: {
          type: "link"
        },
        on: {
          click: function ($event) {
            return _vm.colorClickFun(item1.buttonFontColor, "buttonFontColor", index, index1);
          }
        }
      }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
        staticClass: "selectedItem"
      }, [_c("div", {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
        staticClass: "contBox"
      }, [_c("div", {
        staticClass: "colorBox",
        style: "background:" + item1.buttonBgColor
      }), _c("a-button", {
        staticClass: "size",
        attrs: {
          type: "link"
        },
        on: {
          click: function ($event) {
            return _vm.colorClickFun(item1.buttonBgColor, "buttonBgColor", index, index1);
          }
        }
      }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
        staticClass: "selectedItem"
      }, [_c("div", {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("div", {
        staticClass: "contBox"
      }, [_c("a-input", {
        attrs: {
          maxLength: 15,
          placeholder: _vm.$t("请输入") + "1-15" + _vm.$t("字符")
        },
        on: {
          change: _vm.changeFun
        },
        model: {
          value: item1.buttonName,
          callback: function ($$v) {
            _vm.$set(item1, "buttonName", $$v);
          },
          expression: "item1.buttonName"
        }
      })], 1)]), _c("div", {
        staticClass: "selectedItem"
      }, [_c("div", {
        staticClass: "name"
      }, [_vm._v(_vm._s(_vm.$t("按钮事件")))]), _c("div", {
        staticClass: "contBox"
      }, [_c("a-select", {
        staticStyle: {
          width: "100px"
        },
        attrs: {
          allowClear: ""
        },
        on: {
          change: _vm.changeFun
        },
        model: {
          value: item1.buttonEvent,
          callback: function ($$v) {
            _vm.$set(item1, "buttonEvent", $$v);
          },
          expression: "item1.buttonEvent"
        }
      }, [_c("a-select-option", {
        attrs: {
          disabled: _vm.disabledEvent(item.buttonPopUpConfig.buttonInfo, "close"),
          value: "close"
        }
      }, [_c("a-tooltip", {
        attrs: {
          placement: "top"
        }
      }, [_c("template", {
        slot: "title"
      }, [_c("span", [_vm._v(_vm._s(_vm.$t("关闭弹窗")))])]), _c("span", {
        staticClass: "overflow"
      }, [_vm._v(_vm._s(_vm.$t("关闭弹窗")))])], 2)], 1), _c("a-select-option", {
        attrs: {
          disabled: _vm.disabledEvent(item.buttonPopUpConfig.buttonInfo, "jump"),
          value: "jump"
        }
      }, [_c("a-tooltip", {
        attrs: {
          placement: "top"
        }
      }, [_c("template", {
        slot: "title"
      }, [_c("span", [_vm._v(_vm._s(_vm.$t("跳转页面")))])]), _c("span", {
        staticClass: "overflow"
      }, [_vm._v(_vm._s(_vm.$t("跳转页面")))])], 2)], 1)], 1)], 1)])], 1);
    }), item.buttonPopUpConfig.buttonInfo.length != 2 ? _c("a-button", {
      staticClass: "size",
      staticStyle: {
        padding: "0"
      },
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.addPopupBtnFun(index);
        }
      }
    }, [_vm._v("+" + _vm._s(_vm.$t("增加弹窗按钮")))]) : _vm._e()], 2) : _vm._e()], 1);
  }), _vm.form.buttonInfo && _vm.$route.params.type != "DETAILS" && _vm.$route.params.type != "POLICY_DETAIL_PAGE" && _vm.form.buttonInfo.length != 2 ? _c("a-button", {
    staticClass: "size",
    staticStyle: {
      padding: "0 10px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addBtnFun
    }
  }, [_vm._v(_vm._s(_vm.$t("增加页面按钮")))]) : _vm._e(), _vm.form.buttonInfo && _vm.$route.params.type == "POLICY_DETAIL_PAGE" && _vm.form.buttonInfo.length != 3 ? _c("a-button", {
    staticClass: "size",
    staticStyle: {
      padding: "0 10px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addBtnFun
    }
  }, [_vm._v(_vm._s(_vm.$t("增加页面按钮")))]) : _vm._e()], 2), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };